import { BlueShieldCheckmark as BlueShieldCheckmarkIcon } from 'phosphor-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../atoms/Tooltip/TooltipRadix';
import { RichText } from '../RichText';
import { CertifiedPublisherProps } from './CertifiedPublisher.types';

export const CertifiedPublisher = ({
  microcopy,
  className = '',
}: CertifiedPublisherProps) => {
  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={microcopy.icon}
        className={className}
        data-test="certified-publisher-icon"
      >
        <BlueShieldCheckmarkIcon />
      </TooltipTrigger>

      <TooltipContent>
        <RichText
          html={microcopy.description}
          className="text-gray-400 text-sm [&_p]:mb-0"
        />
      </TooltipContent>
    </Tooltip>
  );
};
